// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3yevA{height:25px}._1j1G1{height:150px}", ""]);
// Exports
exports.locals = {
	"space": "_3yevA",
	"card": "_1j1G1"
};
module.exports = exports;
